import { Module } from 'vuex'
import axios from '@/plugins/axios'

const profileModule: Module<any, any> = {
    state: {
        profiles: [],
        orgProfiles: [],
    },
    actions: {
        async getProfiles({ commit, dispatch }, params) {
        
        	const page = params.uuids?.length ? 'page=1' : 'page=' + (params?.page ?  + params.page : 1)
        
        	const perPage = 
        		params.uuids?.length ? '&itemPerPage=' + params.uuids.length :
					params?.perPage
						? '&itemPerPage=' + params.perPage
						: ''
        	
            const region = params.region ? '&region=' + params.region : ''
            const country = params.country ? '&country=' + params.country : ''
            const network = params.network ? '&network=' + params.network : ''
            let kol = ''
            if (params.reportId && params.kol !== null) {
	            kol = params.kol === true ? '&reportFlags[' + params.reportId + ']=key-opinion-leader' : params.kol === false ? '&excludeReportFlags[' + params.reportId + ']=key-opinion-leader' : ''
            }
            const name = params.name ? '&name=' + params.name : ''
            const vanityName = params.vanityName ? '&vanityName=' + params.vanityName : ''
            const uuids = params.uuids?.map(uuid => '&uuids[]=' + uuid).join('') ?? ''             
            const networkUserId = params.networkUserId ? '&networkUserId=' + params.networkUserId : ''            
            const reportId = params.reportId ? '&reportId=' + params.reportId : ''     
            const networkConnectionIds = params.networkConnectionIds?.map(ncId => '&networkConnectionIds[]=' + ncId).join('') ?? ''             
            const followsNetworkConnectionId = params.followsNetworkConnectionId ? '&followsNetworkConnectionId=' + params.followsNetworkConnectionId : ''                     
            const followsNetworkConnectionIds = params.followsNetworkConnectionIds ? params.followsNetworkConnectionIds.map(ncId => '&followsNetworkConnectionIds[]=' + ncId).join('') : ''                   
            const followsWorkspaceNetworkConnection = params.followsWorkspaceNetworkConnection ? '&followsWorkspaceNetworkConnection=1' : ''                     
            const sort = params.sort ? '&sort=' + params.sort : ''
            const order = params.order ? '&order=' + params.order : ''
            const isAccreditedInvestor = params.isAccreditedInvestor ? '&isAccreditedInvestor=' + params.isAccreditedInvestor : ''

			const publishDateFrom = params.dateRange?.from
				? `&publishDate[from]=${params.dateRange.from}`
				: ''
			const publishDateTo = params.dateRange?.to
				? `&publishDate[to]=${params.dateRange.to}`
				: ''

			 const statsFrom = params.statsFrom
				? `&stats[from]=${params.statsFrom}`
				: ''
			const statsTo = params.statsTo
				? `&stats[to]=${params.statsTo}`
				: ''
            
            const postRange = params.postRange
            ? `&postRange=${params.postRange}`
            : ''

            const followerRange = params.followerRange
            ? `&followerRange=${params.followerRange}`
            : ''

            const isOrg = params.isOrg !== null && params.isOrg !== undefined
                ? `&is_org=${params.isOrg ? '1' : '0'}`
                : ''
                
            const filters = network +
                name +
                vanityName + 
                uuids + 
                country +
                region +
                networkUserId + 
                publishDateFrom + 
                publishDateTo + 
                statsFrom + 
                statsTo +
                reportId + 
                networkConnectionIds +
                followsNetworkConnectionId +
                followsNetworkConnectionIds +
                followsWorkspaceNetworkConnection +
                postRange + 
                followerRange +
                kol + 
                isAccreditedInvestor +
                isOrg
                
            if (!filters.length) {
            	return []
            }

            const { data } = await axios.get(
                '/api/profile?' + 
                page + 
                perPage + 
                filters +
                sort + 
                order
            )

            commit('setProfiles', data ? data['hydra:member'] : null)

            if (params.includeOrgProfiles) {
                dispatch('loadPersonOrgProfiles')
            }

            return data
        },

        async exportProfiles(_, params) {
            const page = params.uuids?.length ? 'page=1' : 'page=' + (params?.page ?  + params.page : 1)
        
        	const perPage = 
        		params.uuids?.length ? '&itemPerPage=' + params.uuids.length :
					params?.perPage
						? '&itemPerPage=' + params.perPage
						: ''

            const region = params.region ? '&region=' + params.region : ''
            const country = params.country ? '&country=' + params.country : ''
            const network = params.network ? '&network=' + params.network : ''
            let kol = ''
            if (params.reportId && params.kol !== null) {
	            kol = params.kol === true ? '&reportFlags[' + params.reportId + ']=key-opinion-leader' : params.kol === false ? '&excludeReportFlags[' + params.reportId + ']=key-opinion-leader' : ''
            }
            const name = params.name ? '&name=' + params.name : ''
            const vanityName = params.vanityName ? '&vanityName=' + params.vanityName : ''
            const uuids = params.uuids?.map(uuid => '&uuids[]=' + uuid).join('') ?? ''             
            const networkUserId = params.networkUserId ? '&networkUserId=' + params.networkUserId : ''            
            const reportId = params.reportId ? '&reportId=' + params.reportId : ''     
            const networkConnectionIds = params.networkConnectionIds?.map(ncId => '&networkConnectionIds[]=' + ncId).join('') ?? ''             
            const followsNetworkConnectionId = params.followsNetworkConnectionId ? '&followsNetworkConnectionId=' + params.followsNetworkConnectionId : ''                     
            const followsNetworkConnectionIds = params.followsNetworkConnectionIds ? params.followsNetworkConnectionIds.map(ncId => '&followsNetworkConnectionIds[]=' + ncId).join('') : ''                   
            const followsWorkspaceNetworkConnection = params.followsWorkspaceNetworkConnection ? '&followsWorkspaceNetworkConnection=1' : ''                     
            const sort = params.sort ? '&sort=' + params.sort : ''
            const order = params.order ? '&order=' + params.order : ''
            const isAccreditedInvestor = params.isAccreditedInvestor ? '&isAccreditedInvestor=' + params.isAccreditedInvestor : ''

			const publishDateFrom = params.dateRange?.from
				? `&publishDate[from]=${params.dateRange.from}`
				: ''
			const publishDateTo = params.dateRange?.to
				? `&publishDate[to]=${params.dateRange.to}`
				: ''

			 const statsFrom = params.statsFrom
				? `&stats[from]=${params.statsFrom}`
				: ''
			const statsTo = params.statsTo
				? `&stats[to]=${params.statsTo}`
				: ''
            
            const postRange = params.postRange
            ? `&postRange=${params.postRange}`
            : ''

            const followerRange = params.followerRange
            ? `&followerRange=${params.followerRange}`
            : ''

            const isOrg = params.isOrg !== null && params.isOrg !== undefined
                ? `&is_org=${params.isOrg ? '1' : '0'}`
                : ''
                
            const filters = network +
                name +
                vanityName + 
                uuids + 
                country +
                region +
                networkUserId + 
                publishDateFrom + 
                publishDateTo + 
                statsFrom + 
                statsTo +
                reportId + 
                networkConnectionIds +
                followsNetworkConnectionId +
                followsNetworkConnectionIds +
                followsWorkspaceNetworkConnection +
                postRange + 
                followerRange +
                kol + 
                isAccreditedInvestor +
                isOrg

            const { data } = await axios.get(
                '/api/profile/export?' +
                page + 
                perPage + 
                filters +
                sort + 
                order
            )

            return data
        },

        async getProfile(_, id) {
            const { data } = await axios.get(`/api/profile/${id}`)
            return data
        },

        async editProfile(_, params) {
            const { data } = await axios.put(`/api/profile/${params.id}`, params)
            return data
        },

        async editProfileImage(_, params) {
            const { data } = await axios.put(`/api/profile/${params.id}/image_upload`, params)
            return data
        },

        async loadPersonOrgProfiles({ commit, dispatch, state }) {

            if (!state.profiles) {
    			throw 'Load activities first!'
    		}
            
            const orgUuids = []
            state.profiles.forEach((profile) => {
                if (profile?.identity.orgUuid && !orgUuids.includes(profile.identity.orgUuid)) {
                    orgUuids.push(profile.identity.orgUuid)
                }
            })

            if (orgUuids.length > 0) {
                await dispatch('getProfiles', {
					uuids: orgUuids,
                    includeOrgProfiles: false
				}).then((response) => {
                    commit('setOrgProfiles', response['hydra:member'] ? response['hydra:member'] : null)
				})
            }

        }
    },
    getters: {
    	getProfileList: (state) => () => {
    		return state.profiles
    	},
    	getOrgProfile: (state) => (uuid) => {
    		return state.orgProfiles?.find(profile => profile.uuid === uuid)
    	},
    },
    mutations: {
        setProfiles(state: any, profiles) {
            if (!state.profiles) {
                state.profiles = []
            }
            profiles?.forEach((profile) => {
                if (!state.profiles.find((stored) => stored.uuid === profile.uuid)) {
                    state.profiles.push(profile)
                }
            })
        },
        setOrgProfiles(state: any, orgProfiles) {
            state.orgProfiles = orgProfiles
        },
    },
}

export default profileModule
